const About = props => {
    return <div class="about"><h1>About</h1>
    This is a react app built with sample stock data and an API to view current details about each stock.<br/>
    <a href="https://financialmodelingprep.com/" target="_blank">API Source</a></div>
}

export default About;